// extracted by mini-css-extract-plugin
module.exports = {"themeContent":"style_themeContent__AEas8","shapeDesktop":"style_shapeDesktop__61vbP","shapeMobile":"style_shapeMobile__yI09I"};